import React, { useEffect } from "react";
import { BrowserRouter, Route, Switch, Redirect, useHistory } from "react-router-dom";
import { Provider } from "react-redux";
import { createStore, applyMiddleware } from "redux";
import createSagaMiddleware from "redux-saga";
import {
  NotificationContainer,
  NotificationManager,
} from "react-notifications";
import PrivateRoute from "./PrivateRoute";
import Login from "./components/Login";
import Dashboard from "./components/Dashboard/Dashboard";
import DashGoogleMapDownload from "./components/Dashboard/DashMapDownload"
import LiveMeterFeed from "./components/LiveMeterFeed/LiveMeterFeed";
import EnergySavingReport from "./components/Reports/EnergySavingReport/EnergySavingReport";
import Settings from "./components/Settings/Settings";
import UserManagement from "./components/UserManagement/UserList";
import logo from "./logo.svg";

import { initializeApp } from "firebase/app";
import {
  getFirestore,
  collection,
  doc,
  query,
  where,
  orderBy,
  startAfter,
  limit,
  getDoc,
  getDocs,
} from "firebase/firestore";
import { getAuth, signInWithEmailAndPassword } from "firebase/auth";
// import { getDatabase } from "firebase/database";

import rootReducer from "./reducers/rootReducer";
import rootSaga from "./sagas/rootSaga";
import { db, getCheckSession, logout } from "./apis/auth";
import { createTheme, ThemeProvider } from "@material-ui/core";
import { blue, orange } from "@material-ui/core/colors";
import EventReport from "./components/Reports/event-report";
import ActiveTickets from "./components/ticket/active-tickets";
import CreateTickets from "./components/ticket/create-tickets";
import ClosedTickets from "./components/ticket/closed-tickets";
import Config from "./components/Config/Config";
import SLCInventory from "./components/inventory/slc-inventory";
import LampInventory from "./components/inventory/lamp-inventory";
import ILMInventory from "./components/inventory/ilm-inventory";
import PoleInventory from "./components/inventory/pole-inventory";
import PermissionConfig from "./components/PermissionConfig/PermissionConfig";
import Project from "./components/Project/Project";
import SummaryInventory from "./components/inventory/summary-inventory";
import LampFailureReport from "./components/Reports/LampFailureReport";
import MorningMock from "./components/MockData/MockSchedule";
import ComListScreen from "./components/Com/Com";

// const firebaseApp = initializeApp({
//   apiKey: "AIzaSyD6TwgmVkLjx8wBcnL09dU-0pJyeRLsEBI",
//   authDomain: "us-central1-ccms-dindigul-qe.cloudfunctions.net/device-summary",
//   projectId: "ccms-dindigul-qe",
//   storageBucket: "ccms-dindigul-qe.appspot.com",
//   messagingSenderId: "391620415322",
//   appId: "1:891444003945:android:2492e99d40b8a84ebc4ef8",
//   messagingSenderId: "891444003945",
// });
// const firebaseConfig = {
//   apiKey: "AIzaSyBrg5hfc-ZMCDuAgZxgnvBwLxOgeo0idcQ",
//   authDomain: "ccms-main-qe.firebaseapp.com",
//   databaseURL:
//     "https://ccms-main-qe-default-rtdb.asia-southeast1.firebasedatabase.app",
//   projectId: "ccms-main-qe",
//   storageBucket: "ccms-main-qe.appspot.com",
//   messagingSenderId: "953826033978",
//   appId: "1:953826033978:web:1147e23b1a06e179811003",
//   measurementId: "G-DRETX2H6X6",
// };
// const firebaseConfig_dindigul = {
//   apiKey: "AIzaSyDcQHEeLFWbCsFjWaQ8AXN8qZPDL0S-dLM",
//   authDomain: "ccms-dindigul-qe.firebaseapp.com",
//   projectId: "ccms-dindigul-qe",
//   storageBucket: "ccms-dindigul-qe.appspot.com",
//   messagingSenderId: "891444003945",
//   appId: "1:891444003945:web:6356bdc79c5ca9e0bc4ef8",
//   measurementId: "G-D6GW5CM5JQ",
// };

const initialState = {};
const sagaMiddleware = createSagaMiddleware();
const store = createStore(
  rootReducer,
  initialState,
  applyMiddleware(sagaMiddleware)
);

sagaMiddleware.run(rootSaga);

// const app = initializeApp(firebaseConfig);
// const db = getFirestore();

// const app1 = initializeApp({
//   databaseURL:
//     "https://ccms-main-qe-default-rtdb.asia-southeast1.firebasedatabase.app"
// });
// const app2 = initializeApp({
//   databaseURL:
//     "https://ccms-dindigul-qe-default-rtdb.asia-southeast1.firebasedatabase.app"
// }, 'app2');
// const database1 = getDatabase(app1);
// const database2 = getDatabase(app2);

function App() {
  const history = useHistory();
  //   const getDbData = async () => {
  // const first = query(
  //       collection(db, "devices"),
  //       where("ins_st", "==", 2),
  //       orderBy("dev_id"),
  //       limit(10)
  //     );
  //     const documentSnapshots = await getDocs(first);
  //     console.log("documentSnapshots : ", documentSnapshots);
  //     const dashboardReport = [];
  //     documentSnapshots.forEach((doc) => {
  //       console.log("doc snapshots : ", doc.data());
  //       const dataDoc = doc.data();
  //       if (dataDoc) {
  //         const { dev_id, loc, dev_md, loc, up_dt, lmp_cnt, lmp_off_cnt } =
  //           dataDoc;
  //         dashboardReport = [...dashboardReport, {}];
  //       }
  //     });

  //     const lastVisible =
  //       documentSnapshots.docs[documentSnapshots.docs.length - 1];
  //   };

  const callAuthenticateAPI = async (email, password) => {
    const auth = getAuth();
    signInWithEmailAndPassword(auth, email, password)
      .then((userCredential) => {
        // Signed in
        const user = userCredential.user;
        console.log("successssss !!!");
        // ...
      })
      .catch((error) => {
        const errorCode = error.code;
        const errorMessage = error.message;
        console.log("Failure !!!!");
      });
  };

  useEffect(async () => {
    // await getCheckSession().then(() => {
    //   history.push("/dashboard");
    // }).catch((e) => {
    // });

    let dbName = "";
    // const url =
    //   "https:/us-central1-ccms-main-qe.cloudfunctions.net/user?userEmail=admin@admin.com&clientType=2";
    // fetch(url)
    //   .then((res) => res.json())
    //   .then((data) => console.log("data : ", data))
    //   .catch((err) => console.log(err));

    // getDbData();
    // callAuthenticateAPI("sudhankumarr@gmail.com", "123456");

    // const q = query(collection(db, "users"), where("user_email", "==", "sudhankumarr@gmail.com"));
    // const querySnapshot = await getDocs(q);
    // querySnapshot.forEach(doc => {
    //   console.log("users docs : ", doc.data());
    //   let selectedDoc = doc.data();
    //   dbName = selectedDoc.db_name;
    // });
    // console.log('db name : ', dbName);
    // let firebaseConfig_specific_city = null;

    // const docRef = doc(db, "db_settings", `${dbName}_web`);
    // const docSnap = await getDoc(docRef);
    // if (docSnap.exists()) {
    //   console.log('doc snap config : ', docSnap.data());
    //   firebaseConfig_specific_city = docSnap.data();
    // }
    // if (firebaseConfig_specific_city) {
    //   initializeApp(firebaseConfig_specific_city);
    // }
  }, []);

  // const history = useHistory();

  return (
    <div className="App">
      <Provider store={store}>
        <ThemeProvider theme={theme}>
          <NotificationContainer />
          <BrowserRouter history={history}>
            <Switch>
              <Route exact path="/" render={(props) => <Login {...props} />} />
              <PrivateRoute exact path="/dashboard" component={Dashboard} />
              <PrivateRoute
                exact
                path="/live-meter-feed"
                component={LiveMeterFeed}
              />
              <PrivateRoute exact path="/settings" component={Settings} />
              <PrivateRoute exact path="/mock" component={MorningMock} />
              <PrivateRoute exact path="/config" component={Config} />
              <PrivateRoute path="/reports" component={EnergySavingReport} />
              <PrivateRoute path="/user" component={UserManagement} />
              <PrivateRoute path="/event-report" component={EventReport} />
              <PrivateRoute path="/create-tickets" component={CreateTickets} />
              <PrivateRoute path="/active-tickets" component={ActiveTickets} />
              <PrivateRoute path="/slc-inventory" component={SLCInventory} />
              <PrivateRoute path="/lamp-inventory" component={LampInventory} />
              <PrivateRoute path="/ilm-inventory" component={ILMInventory} />
              <PrivateRoute path="/pole-inventory" component={PoleInventory} />
              <PrivateRoute path="/summary-inventory" component={SummaryInventory} />
              <PrivateRoute path="/permission" component={PermissionConfig} />
              <PrivateRoute path="/Project" component={Project} />
              <PrivateRoute path="/com-list" component={ComListScreen} />
              <PrivateRoute path="/lamp-error-report" component={LampFailureReport} />
              <PrivateRoute path="/closed-tickets" component={ClosedTickets} />
              <Route exact path="/slc-print" render={(props) => <DashGoogleMapDownload {...props} />} />
              <Redirect to="/" />
            </Switch>
          </BrowserRouter>
        </ThemeProvider>
      </Provider>
    </div>
  );
}

export default App;

const theme = createTheme({
  palette: {
    primary: blue,
  }
});

